// src/api/roles.js
import { uri } from '../constants';

export const getRoles = async () => {
  try {
    const response = await fetch(`${uri}/artist_roles`);
    if (!response.ok) throw new Error('Failed to fetch artist_roles');
    return await response.json();
  } catch (error) {
    console.error('Error fetching artist_roles:', error);
    throw error;
  }
};

export const createRole = async (roleData) => {
  try {
    const response = await fetch(`${uri}/artist_roles`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(roleData)
    });
    if (!response.ok) throw new Error('Failed to create role');
    return await response.json();
  } catch (error) {
    console.error('Error creating role:', error);
    throw error;
  }
};

export const deleteRole = async (roleId) => {
  try {
    const response = await fetch(`${uri}/artist_roles/${roleId}`, {
      method: 'DELETE'
    });
    if (!response.ok) throw new Error('Failed to delete role');
    return await response.json();
  } catch (error) {
    console.error('Error deleting role:', error);
    throw error;
  }
};